"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Headers = void 0;
exports.getBearerToken = getBearerToken;
var Headers;
(function (Headers) {
    Headers["AUTHORIZATION"] = "authorization";
})(Headers || (exports.Headers = Headers = {}));
const HEADER_PREFIX = "Bearer ";
function getBearerToken(authHeaderValue) {
    if (authHeaderValue && authHeaderValue.startsWith(HEADER_PREFIX)) {
        return authHeaderValue.substring(HEADER_PREFIX.length);
    }
    return null;
}
